import React from "react";
import Enrolment from "../Enrolment";

const EnrollmentSummaryReportComponent = () => {
  return <Enrolment status="report" title="summary" />;
};

export default EnrollmentSummaryReportComponent;
